import { ERP } from '../_base/endpoint';
import axios from 'axios';

class authService {
    async signIn(data) {
        const response = await axios
            .post(`${ERP}seguridad/authentication`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                if (error.response !== undefined)
                    return error.response;
            });
        return response === undefined ? {} : response;
    };

    async recoverPassword(data) {
        var url = `${ERP}seguridad/authentication/recover-password`;
        
        const response = await axios
            .put(url, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

}

export default new authService();